<div class="modal-header">
  <div>
    <h4 class="modal-title f-w-600" id="exampleModalLabel">
      {{ "profile.updatePassword.title" | translate }}
    </h4>
    <h5 class="m-b-0 m-t-10">
      {{ companyName }}
    </h5>
  </div>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>
<div class="modal-body">
  <form class="theme-form" [formGroup]="form">
    <div class="mb-3 form-group">
      <label class="col-form-label pt-0" for="exampleInputPassword2"
        >{{ "profile.updatePassword.newPassword" | translate }} *</label
      >
      <div class="input-group">
        <input
          class="form-control"
          id="exampleInputPassword2"
          [type]="showPassword ? 'text' : 'password'"
          appIgnorePasswordManagers
          formControlName="newPassword"
          [placeholder]="
            'updatePasswordByAdmin.placeholders.newPassword' | translate
          "
          [ngClass]="{
            'is-invalid':
              !form.get('newPassword')?.valid &&
              form.get('newPassword')?.touched
          }"
        />
        <div
          class="show-hide"
          (click)="clickShowPassword()"
          *ngIf="!showPassword"
        >
          <span> {{ "password.show" | translate }} </span>
        </div>
        <div
          class="show-hide"
          (click)="clickShowPassword()"
          *ngIf="showPassword"
        >
          <span>{{ "password.cash" | translate }}</span>
        </div>
        <div
          class="invalid-feedback"
          *ngIf="
            !form.get('newPassword')?.valid && form.get('newPassword')?.touched
          "
        >
          {{ "errorMsg.validPassword" | translate }} *
          <ul style="padding-left: 10px">
            <li>- {{ "password.pattern.validator1" | translate }}</li>
            <li>- {{ "password.pattern.validator2" | translate }}</li>
            <li>- {{ "password.pattern.validator3" | translate }}</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="mb-3 form-group">
      <label class="col-form-label pt-0" for="exampleInputPassword3"
        >{{ "profile.updatePassword.confirmNewPassword" | translate }} *</label
      >
      <div class="input-group">
        <input
          class="form-control"
          id="exampleInputPassword3"
          [type]="showNewPassword ? 'text' : 'password'"
          appIgnorePasswordManagers
          formControlName="reNewPassword"
          [placeholder]="
            'updatePasswordByAdmin.placeholders.confirmPassword' | translate
          "
          [ngClass]="{
            'is-invalid':
              !form.get('reNewPassword')?.valid &&
              form.get('reNewPassword')?.touched
          }"
        />
        <div
          class="show-hide"
          (click)="clickShowNewPassword()"
          *ngIf="!showNewPassword"
        >
          <span> {{ "password.show" | translate }} </span>
        </div>
        <div
          class="show-hide"
          (click)="clickShowNewPassword()"
          *ngIf="showNewPassword"
        >
          <span>{{ "password.cash" | translate }}</span>
        </div>
        <div
          class="invalid-feedback"
          *ngIf="
            !form.get('reNewPassword')?.valid &&
            form.get('reNewPassword')?.touched
          "
        >
          <div style="padding-left: 10px">
            {{ "password.matchPassword" | translate }}
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-outline-primary"
    data-bs-dismiss="modal"
    (click)="close()"
  >
    {{ "buttons.close" | translate }}
  </button>
  <button class="btn btn-primary" (click)="update()" [disabled]="!form.valid">
    <loading-button
      [loading]="loading"
      [value]="'buttons.confirm' | translate"
      [icon]="null"
    ></loading-button>
  </button>
</div>
